<template>
  <ul class="help-page">
    <li class="help-page__item"><a href="/faq" class="help-page__link">よくある質問</a></li>
    <li class="help-page__item"><a href="/help/inquiry" class="help-page__link">お問い合わせ</a></li>
    <li class="help-page__item"><a href="/privacy" class="help-page__link">プライバシーポリシー</a></li>
    <li class="help-page__item"><a href="/terms" class="help-page__link">利用規約</a></li>
    <li class="help-page__item"><a href="/cookie" class="help-page__link">Cookie利用について</a></li>
    <li class="help-page__item"><a href="/legal" class="help-page__link">特定商取引法に基づく表記</a></li>
    <li class="help-page__item"><a href="https://www.zappallas.com/" target="_blank" class="help-page__link">運営会社</a></li>
  </ul>
</template>

<script>
export default {
  name: "HelpPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.help-page {
  color: $col_base_black;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 -16px;
  padding: 0;
  &__item {
    display: block;
  }
  &__link {
    display: block;
    padding: 14px 20px;
    position: relative;
    border-bottom: 1px solid $col_temp_gray3;
    color: inherit;
    text-decoration: none;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 14px;
      margin: auto;
      width: 24px;
      height: 24px;
      background: url('/static/img/common/arrow_right.svg') no-repeat 50% 50%/contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Help.vue